import { render, staticRenderFns } from "./PromoProductColorListModal.vue?vue&type=template&id=188c822c&scoped=true&"
import script from "./PromoProductColorListModal.vue?vue&type=script&lang=js&"
export * from "./PromoProductColorListModal.vue?vue&type=script&lang=js&"
import style0 from "./PromoProductColorListModal.vue?vue&type=style&index=0&id=188c822c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c822c",
  null
  
)

export default component.exports